import { useState } from "react";
import { API_URL } from "../api/api";
import { useNavigate } from "react-router-dom";

export default function StaffCreate() {
  const nav = useNavigate();
  const [form, setForm] = useState({
    nama: "",
    email: "",
    password: "",
    role: "admin"
  });
  const [error, setError] = useState("");

  const submit = async () => {
    const res = await fetch(`${API_URL}/admin/users/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      body: JSON.stringify(form)
    });

    const data = await res.json();
    if (!data.success) {
      setError(data.message);
      return;
    }
    nav("/staff");
  };

  return (
    <div className="max-w-md bg-white p-6 rounded shadow">
      <h1 className="text-xl font-bold mb-4">Tambah Staff</h1>

      {["nama", "email", "password"].map(f => (
        <input
          key={f}
          type={f === "password" ? "password" : "text"}
          placeholder={f}
          className="border p-2 w-full mb-2"
          onChange={e => setForm({ ...form, [f]: e.target.value })}
        />
      ))}

      <select
        className="border p-2 w-full mb-2"
        onChange={e => setForm({ ...form, role: e.target.value })}
      >
        <option value="admin">Admin</option>
        <option value="bidan">Bidan</option>
      </select>

      {error && <p className="text-red-500">{error}</p>}

      <button onClick={submit} className="bg-blue-600 text-white w-full py-2 rounded">
        Simpan
      </button>
    </div>
  );
}
